const AuctionStore = {
  state: {
    turn: null,
  },
  mutations: {
    setAuctionTurn(state, { turn }) {
      state.turn = turn;
    },
  },
};

export default AuctionStore;
